import { all } from "redux-saga/effects"
import initForm from "./initForm"
import submitForm from "./submitForm"

export default function* rolesFormSaga() {
  while (true) {
    yield all({
      fetch: initForm(),
      release: submitForm(),
    })
  }
}
